import { bindable, ICustomElementViewModel } from 'aurelia';
import './db-skeleton-loader.scss';

export class DbSkeletonLoader implements ICustomElementViewModel {
    @bindable visible: boolean = true;
    @bindable showBreadcrumbs: boolean = true;
    @bindable showBanner: boolean = false;
    @bindable showHeading: boolean = true;
    @bindable showBlogInfo: boolean = false;
    @bindable showInputs: boolean = false;
    @bindable showAuthor: boolean = false;
    @bindable showContent: boolean = false;
    @bindable showPosts: boolean = true;
    @bindable showRelated: boolean = false;
    @bindable showPagination: boolean = true;
    @bindable showDividers: boolean = true;
    @bindable postsCount: number = 3;
    @bindable relatedCount: number = 0;
    @bindable contentCount: number = 0;

    getArray(count: number): number[] {
        return Array.from({ length: count });
    }
}
